<ng-content select="figure"></ng-content>

<div class="data"><ng-content></ng-content></div>
